module.exports = __webpack_public_path__ + "img/accident_crash.af0222ba.svg";